import { Alert } from "@/ui/alert";
import { useEstado } from "../estado.jsx";

/**
 * A faixa de "reconectando à mesa".
 *
 * O canal de eventos (`GET /api/stream`) cai com a rede, com o servidor
 * reiniciando e com o notebook voltando do sono. O `EventSource` reconecta
 * sozinho, e era exatamente esse silêncio o problema: entre a queda e a volta a
 * mesa mostra um retrato congelado do WhatsApp — mensagem nova não entra, prazo
 * novo não aparece — e a sala segue achando que está ouvindo o telefone.
 *
 * Faixa fina no alto e não recado no rodapé: o recado morre em seis segundos e
 * este estado dura enquanto durar. `role="status"` (cortês) porque não é falha
 * do que a pessoa acabou de fazer; é o ambiente — e é por isso que o `role` do
 * `Alert` (assertivo) é sobrescrito aqui.
 */
export default function FaixaCanal() {
  const { canalInstavel } = useEstado();
  if (!canalInstavel) return null;
  return (
    /* Abaixo da faixa de cima, não em cima dela: a marca e o sino ficam
        legíveis, e o aviso continua sendo a primeira coisa acima da mesa. */
    <div className="pointer-events-none absolute inset-x-0 top-[var(--barra-da-mesa)] z-[58] flex justify-center p-2">
      {/* A faixa é âmbar escuro com letra creme, e não a moldura de cartão do
          preset: ela flutua sobre a conversa e precisa ser lida de longe. */}
      <Alert
        role="status"
        className="w-auto animate-[vFade_var(--t-curta)_var(--e-entra)_both] rounded-[9px] border-transparent bg-ambar-escuro px-[13px] py-1.5 text-apoio font-semibold tracking-[.02em] text-creme shadow-[0_10px_26px_color-mix(in_oklab,_var(--color-foreground)_22%,_transparent)]"
      >
        Reconectando à mesa — mensagem nova pode não estar aparecendo
      </Alert>
    </div>
  );
}
